import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";

interface Props {
  title: string;
  value: string | number;
  options: any[];
  sx?: any;
  onChange(value: any): void;
  errorMessage?: string;
}

const DropDown: React.FC<Props> = ({
  title, value, options, sx, onChange, errorMessage
}: Props) => {
  return (
    <FormControl sx={sx ?? {}} error={errorMessage ? true : false}>
      <InputLabel>{title}</InputLabel>
      {options?.length > 0 &&
        <Select
          label={title}
          value={value}
          onChange={onChange}
        >
          {options.map((item) => (
            <MenuItem
              key={item.value}
              value={item.value}
              style={item.value ? {} : {fontStyle: "italic"}}
            >
              {item.name}
            </MenuItem>
          ))}
        </Select>
      }
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
}
export default DropDown;
